import {HELP_LOG} from '@/constants/help/log';
import LogApi from '@/api/common/log';

export const sendHelpClickLog = (
  codeType: (typeof HELP_LOG.CODE_TYPE)[keyof typeof HELP_LOG.CODE_TYPE],
  sendData: {
    buttonType: (typeof HELP_LOG.BUTTON_TYPE)[keyof typeof HELP_LOG.BUTTON_TYPE];
    actionType?: (typeof HELP_LOG.ACTION_TYPE)[keyof typeof HELP_LOG.ACTION_TYPE];
    text?: string;
  },
) => {
  const params = {
    codeType,
    sendData: {location: 'help_center', ...sendData},
  };

  LogApi.sendClickLog(params);
};
